module.exports = __webpack_public_path__ + "img/logo-pia.5de19331.png";